import { IntroManifesto } from "@/components/IntroManifesto";

export default function Home() {
  return (
    <main>
      <IntroManifesto />
    </main>
  );
}
